import { render, staticRenderFns } from "./ProductVarieties.vue?vue&type=template&id=df6bbe0c&scoped=true&"
import script from "./ProductVarieties.vue?vue&type=script&lang=js&"
export * from "./ProductVarieties.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/product/ProductVarieties/ProductVarietiesStyle.css?vue&type=style&index=0&id=df6bbe0c&scoped=true&lang=css&"
import style1 from "@@/core/components/product/ProductVarieties/ProductVarietiesStylePublic.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6bbe0c",
  null
  
)

export default component.exports